import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCVve_d0Pq4p_cTnGhrtAYDeQNOXyFNzv0",
  authDomain: "mytime-d6735.firebaseapp.com",
  projectId: "mytime-d6735",
  storageBucket: "mytime-d6735.firebasestorage.app",
  messagingSenderId: "936574881522",
  appId: "1:936574881522:web:09c194d30f82d0149c4a6b",
  measurementId: "G-M4LXGHGKTW"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Set session persistence
setPersistence(auth, browserLocalPersistence).catch((error) =>
  console.error("Error setting persistence:", error)
);
